import type { BuilderContent } from '@builder.io/react'
import type { BuilderContent as BuilderContentSDK } from '@builder.io/sdk'
import type { ImageLoaderProps } from 'next/image'

const urls = ['cdn\\.builder\\.io/api/v1/image', 'res\\.cloudinary\\.com/teambeachbody/image']
const imgUrlRegex = new RegExp(`https?://(${urls.join('|')})[^\n)"\']*`)

/**
 * Proxy the images from Builder.io to Next.js Image Optimization API.
 * Needed to leverage the Vercel Edge Cache for the images elements generated by Builder.io.
 **/
export function proxyImages(data: BuilderContent | BuilderContentSDK) {
  function replacer(key: string, value: any) {
    const imgUrl = imgUrlRegex.exec(value)?.[0]
    if (imgUrl) {
      return value.replace(imgUrlRegex, `/api/image-proxy?url=${encodeURIComponent(imgUrl)}`)
    } else {
      return value
    }
  }
  return JSON.parse(JSON.stringify(data, replacer))
}

/**
 * Custom image loader for Next.js Image component. Used in next.config.js
 * @see https://nextjs.org/docs/pages/api-reference/components/image#loaderfile
 */
export default function ImageProxyLoader({ src, width, quality }: ImageLoaderProps) {
  if (src.includes('/api/image-proxy')) return src
  return `/_next/image?url=${encodeURIComponent(src)}&w=${width}&q=${quality ?? 75}`
}
